import type {
  Country,
  Locale,
  SalesforceLanguageCodeEnum,
} from '@/types/regionTypes';

import type { LanguageOption } from '@/views/SignUpView/helper';

export const resolveLanguageCode = (
  userPreferredCountry: Country | undefined,
  userPreferredLanguageCode: string | undefined,
  routerLanguageCode: string,
): string => {
  if (userPreferredCountry) {
    const supportedLanguageCodes =
      userPreferredCountry.locales?.map((locale) => locale.sfCode) ?? [];
    if (
      userPreferredLanguageCode &&
      supportedLanguageCodes.includes(
        userPreferredLanguageCode as SalesforceLanguageCodeEnum,
      )
    ) {
      return userPreferredLanguageCode;
    }

    if (supportedLanguageCodes.length > 0) {
      return supportedLanguageCodes[0];
    }
  }

  return routerLanguageCode;
};

export const getDefaultLanguageOptions = (
  locales?: Locale[],
): LanguageOption[] => {
  const languageOptions = locales?.map((value) => ({
    ...value,
    value: value.sfCode,
    label: value.name,
  }));
  return languageOptions ?? [];
};
